export default "__VITE_ASSET__He_AW8LM__"